import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#60A5FA',
            contrastText: '#ffffff',
        },
    },
});
